import { Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { WebSocketService } from './web-socket.service';

@Injectable({
  providedIn: 'root',
})
export class OperationTrackingService {
  constructor(
    private webSocketService: WebSocketService,
    private authService: AuthService,
  ) {}

  async follow(operationId: string, onProgress?: (percentage: number, detail: string) => void): Promise<any> {
    const outcome = await this.webSocketService.trackOperation(
      operationId,
      await this.ephemeralToken(),
      (message) => {
        if (typeof message?.total_percentage !== 'number') return;
        onProgress?.(message.total_percentage, this.webSocketService.progressDetail(message));
      },
      () => this.ephemeralToken(),
    );
    if (outcome.error) throw { error: outcome.error };
    return outcome.result;
  }

  private async ephemeralToken(): Promise<string> {
    return (await this.authService.getEphemeralToken()) as string;
  }
}
